__turbopack_context__.v({
  "modalCloseButton": "SSpcuq_modalCloseButton",
  "modalContainer": "SSpcuq_modalContainer",
  "modalContent": "SSpcuq_modalContent",
  "modalContentCategory": "SSpcuq_modalContentCategory",
  "modalContentCategoryHeader": "SSpcuq_modalContentCategoryHeader",
  "modalContentCategoryItem": "SSpcuq_modalContentCategoryItem",
  "modalContentCategoryItems": "SSpcuq_modalContentCategoryItems",
  "modalFooter": "SSpcuq_modalFooter",
  "modalFooterCategory": "SSpcuq_modalFooterCategory",
  "modalFooterCategoryContent": "SSpcuq_modalFooterCategoryContent",
  "modalFooterCategoryContentButton": "SSpcuq_modalFooterCategoryContentButton",
  "modalFooterCategoryHeader": "SSpcuq_modalFooterCategoryHeader",
  "modalHeader": "SSpcuq_modalHeader",
  "modalHeaderSubtitle": "SSpcuq_modalHeaderSubtitle",
  "modalHeaderTitle": "SSpcuq_modalHeaderTitle",
});
